// extracted by mini-css-extract-plugin
export default {"container":"LogoutButton_container__OIB-i"};